module.exports = __webpack_public_path__ + "static/delve-nyc-logo-text-1dad0bae46ba2da0a4e83975bdfb644e.png";